// extracted by mini-css-extract-plugin
module.exports = {"FeaturesPage":"featuresPage-module--FeaturesPage--nNLwb","Container":"featuresPage-module--Container--J3-Q9","Hero":"featuresPage-module--Hero--2FVyL"};